<template>
  <!--
      	作者：kmdshop
      	时间：2019-06-04
      	描述：插件中心-优惠券-优惠券列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="formInline.search" placeholder="请输入产品SkuID"></el-input></el-form-item>
        <el-form-item label="">
            <el-select v-model="formInline.status" @change="onSubmit" placeholder="请选择">
              <el-option label="待报销" :value="0">
              </el-option>
              <el-option label="已报销" :value="1">
              </el-option>
              <el-option label="已驳回" :value="2">
              </el-option>
              <el-option label="还未提交报销" :value="3">
              </el-option>
              <el-option label="全部" value="" >
              </el-option>
            </el-select>
          </el-form-item>
        
        <el-form-item><el-button type="primary" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    <div class="common-level-rail">
    
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="approve_log_id" label="ID" width="100"></el-table-column>
            <el-table-column prop="rel_val.product_sku_id" label="产品Sku_id" width="100"></el-table-column>
            <el-table-column prop="rel_val.product_name" label="产品名称" width="100"></el-table-column>
            <el-table-column prop="num" label="报销数量"></el-table-column>
            <el-table-column prop="actual_num" label="实际报销数量"></el-table-column>
            <el-table-column prop="create_time" label="申请时间" width="135"></el-table-column>
            <el-table-column prop="create_time" label="状态" width="135">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">待报销</div>
                <div v-if="scope.row.status == 1">已报销</div>
                <div v-if="scope.row.status == 2">已驳回</div>
                <div v-if="scope.row.status == 3">还未提交报销</div>
              </template>

            </el-table-column>
            <el-table-column prop="reject_reason" label="驳回理由" width="135"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button  v-if="scope.row.status == 0" @click="auditClick(scope.row)" type="text" size="small">通过</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="请确认实际报销数量" :visible.sync="bohui_status" @close="dialogFormVisible" 
    :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="display: flex;">
        <div style="flex:1.5;">待报销数量:</div>
        <el-input style="flex:8.5;" v-model="item.num" disabled type="number"></el-input>
      </div>

      <div style="display: flex;margin-top: 20px;">
        <div style="flex:1.5;">实际报销数量:</div>
        <el-input style="flex:8.5;" v-model="formInline.actual_num" type="number"></el-input>
      </div>

      <div style="display: flex;margin-top: 20px;" v-if="item.num > formInline.actual_num">
        <div style="flex:1.5;">原因:</div>
        <el-input style="flex:8.5;"  v-model="formInline.reject_reason"  type="textarea"></el-input>
      </div>
     
     
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="sure_reject">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import ExpensesApi from '@/api/expenses.js';
  export default {
    data() {
      return {
        formInline: {
          search:"",
          status:0,
          reject_reason:"",
          actual_num:0,
        },
        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,
        setting:{},
        bohui_status:false,
        item:{},
        
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      onSubmit(){
        this.getData()
      },
      /*获取列表*/
      getData() {
        let self = this;
        let Params =self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        ExpensesApi.getExpensesList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list;
            self.setting =  data.data.setting;
            if(self.tableData.length > 0){
              self.totalDataNumber = data.data[0].total
            }
            
          })
          .catch(error => {});
      },
      // rejectClick(item){//驳回审核
      //   this.bohui_status = true
      //   this.item = item;
        
      // },

      sure_reject(){//通过报销审核
        let self = this;
        let Params ={
          "code": "expenses",
          "actual_num":self.formInline.actual_num,
          "approve_log_id":self.item.approve_log_id,
          "reject_reason":self.formInline.reject_reason,
        };

        ExpensesApi.auditExpenses(Params, true)
          .then(data => {
            self.loading = false;
            self.getData()
            if(data.code == 1){
              self.$notify({
                    message: data.msg,
                    type: 'success'
                });
                self.bohui_status = false;
            }else{
                  self.$notify({
                      message: data.msg,
                      type: 'error'
                  });
            }
            
          })
          .catch(error => {});
        // let Params ={
        //   "b_audit_id":self.setting.user_id,//设置后台审核人
        //   "approve_no":self.item.approve_no,
        //   "reject_reason":self.formInline.reject_reason
        // };

        // ExpensesApi.rejectExpenses(Params, true)
        //   .then(data => {
        //     self.loading = false;
        //     if(data.code == 1){
        //       self.$notify({
        //             message: data.msg,
        //             type: 'success'
        //         });
        //         self.bohui_status = false
        //     }else{
        //           self.$notify({
        //               message: data.msg,
        //               type: 'error'
        //           });
        //     }
        //     self.getData()
            
        //   })
        //   .catch(error => {});

      },
      auditClick(item){//通过报销审核
        let self = this;
        console.log("?????")
        this.bohui_status = true
        this.item = item;
        this.formInline.actual_num =  item.num
        return;
 

      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
        /*关闭弹窗*/
    dialogFormVisible(e) {
      this.bohui_status = false
    }

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/expenses/expenses/index.vue